import { render, staticRenderFns } from "./PlusIcon.vue?vue&type=template&id=0aed58f7&"
import script from "./PlusIcon.vue?vue&type=script&lang=ts&"
export * from "./PlusIcon.vue?vue&type=script&lang=ts&"
import style0 from "./PlusIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports